import { SubItem } from './sub-item';
export class CheckList 
{
    id: number|undefined;
    checked:boolean;
    commentaire:string;
    username:string;
    creationDate:string;
    subItem:SubItem
}
  